import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import Sorting from './sorting';

const Filtering = ({ sort, indexParams }) =>
  (<div className="halfmargined-bottom">
    <div className="g-container">
      <div className="g-col-12 search-filters-bar">
        <div className="pull-left">
          <div className="search-condition-filters">
            <a
              className={
                classNames(
                  'btn btn-small btn-flat',
                  { 'btn-active': indexParams.free },
                )
              }
              data-filter="free"
              rel="nofollow"
              onClick={() => indexParams.toggleFree()}
            >
              {I18n.t('digitalListing.free')}
            </a>
            <a
              className={
                classNames(
                  'btn btn-small btn-flat ml-half',
                  { 'btn-active': indexParams.showAllPaid },
                )
              }
              data-filter="paid"
              rel="nofollow"
              onClick={() => indexParams.togglePaid()}
            >
              {I18n.t('digitalListing.paid')}
            </a>
          </div>
        </div>
        <div className="pull-right filter-margined-left">
          <Sorting sort={sort} indexParams={indexParams} />
        </div>
      </div>
    </div>
   </div>);

Filtering.propTypes = {
  sort: PropTypes.string,
  indexParams: PropTypes.object.isRequired,
};

export default Filtering;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/filtering.jsx